import API from '@/js/data/API'
import store from '@/store'


const DataScrapbooks = {
  async getList () {
    try {
      let params = {slug: '/api/scrapbooks/all'}
      let data = await API.getData(params)
      store.dispatch('setUserScrapbooks', data)
      return data
    } catch(err) {
      return false
    }

  },

  async add (params) {
    try {
      let p = {slug: '/api/scrapbook/add', apiParams: {name: params.name}}
      let data = await API.getData(p)
      DataScrapbooks.getList()
      return data
    } catch (err) {
      return new Error(err)
    }
  },

  async addItemToScrapbook (params) {
    try {
      let p = {slug: '/api/scrapbook/additem', apiParams: {scrapbook_id: params.scrapbook_id, item_id: params.item_id}}
      let data = API.getData(p)
      DataScrapbooks.getScrapbookData()
      return data
    } catch (err) {
      return new Error(err)
    }
  },

  async deleteItemFromScrapbook (params) {
    try {
      let p = {slug: '/api/scrapbook/deleteitem', apiParams: {scrapbook_id: params.scrapbook_id, item_id: params.item_id}}
      let data = API.getData(p)
      DataScrapbooks.getScrapbookData()
      return data
    } catch (err) {
      return new Error(err)
    }
  },

  async deleteScrapbook (scrapbook) {
    try {
      let p = {slug: '/api/scrapbook/delete', apiParams: {scrapbook: scrapbook}}
      let data = await API.getData(p)
      DataScrapbooks.getList()
      return data
    } catch (err) {
      return new Error(err)
    }
  },

  async getScrapbookData () {
    try {
      let p = {slug: '/api/scrapbooks/getalldata'}
      let data = await API.getData(p)
      console.log('gettingscrapbookdata')
      console.log(data)
      store.dispatch('setScrapbooksItems', data.byScrapbook)
      store.dispatch('setItemsScrapbooks', data.byItem)
      return data
    } catch (err) {
      return new Error(err)
    }
  }
}

export default DataScrapbooks
